<template>
  <v-app>
    <Header />
    <main class="stolen-pass" id="main-content" tabindex="-1">
      <div class="box-cont">
        <h1>Pass Not Yet Verified!</h1>
        <p>
          This pass wasn't scanned when sold, so we don't have record of the
          sale. Fill out the form below so we can help you register your pass.
        </p>
      </div>
      <div class="box-cont">
        <h2>Contact</h2>
        <p class="tiny-text">* Required Information</p>
        <v-text-field
          label="First Name *"
          aria-required="true"
          v-model="first_name"
          :error-messages="errors.first_name"
          filled
          dense
          color="primary"
          error-color="#D0021B"
          background-color="grey lighten-4"
          class="reg-textfield"
        />
        <v-text-field
          label="Last Name *"
          aria-required="true"
          v-model="last_name"
          :error-messages="errors.last_name"
          filled
          dense
          color="primary"
          error-color="#D0021B"
          background-color="grey lighten-4"
          class="reg-textfield"
        />
        <v-text-field
          label="Email *"
          aria-required="true"
          v-model="email"
          :error-messages="errors.email"
          filled
          dense
          color="primary"
          error-color="#D0021B"
          background-color="grey lighten-4"
          class="reg-textfield"
        />
        <v-text-field
          label="Phone Number *"
          aria-required="true"
          v-model="phone"
          :error-messages="errors.phone"
          filled
          dense
          color="primary"
          error-color="#D0021B"
          background-color="grey lighten-4"
          class="reg-textfield"
        />
      </div>
      <div class="box-cont">
        <h2>Purchase Information</h2>
        <p>Which park did you purchase this pass at? *</p>
        <v-select
          label="Select Park *"
          aria-required="true"
          v-model="selectedPark"
          :items="ParkList"
          :error-messages="errors.selectedPark"
          filled
          dense
          color="primary"
          error-color="#D0021B"
          background-color="grey lighten-4"
          class="reg-textfield"
        />
      </div>
      <div class="box-cont">
        <h2>Proof of Purchase</h2>
        <p>Attach images of any receipts or proof of purchase if available.</p>
        <div class="center">
          <input
            type="file"
            ref="fileInput"
            @change="handleFileSelect"
            accept="image/*"
            multiple
            style="display: none"
          />
          <button
            class="green-button"
            @click="$refs.fileInput.click()"
            type="button"
          >
            <span><img src="../assets/icons/attach.svg" alt="" /></span>Attach
            Images
          </button>
        </div>
        <div v-if="attachedImages.length > 0" class="attached-images">
          <h3>Attached Images ({{ attachedImages.length }})</h3>
          <div class="image-list">
            <div
              v-for="(image, index) in attachedImages"
              :key="index"
              class="image-item"
            >
              <img
                :src="image.preview"
                :alt="image.name"
                class="image-preview"
              />
              <div class="image-info">
                <span class="image-name">{{ image.name }}</span>
                <span class="image-size">{{ formatFileSize(image.size) }}</span>
              </div>
              <button
                @click="removeImage(index)"
                class="remove-button"
                type="button"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="box-cont">
        <h2>Comments</h2>
        <v-textarea
          label="Leave any comments"
          v-model="comments"
          filled
          color="primary"
          error-color="#D0021B"
          background-color="grey lighten-4"
          rows="6"
          no-resize
          class="comments-textarea"
        />
      </div>
      <div class="box-cont center">
        <button
          class="green-button submit-button"
          @click="submitForm"
          :disabled="isSubmitting"
          type="button"
        >
          <span v-if="isSubmitting" class="spinner"></span>
          {{ isSubmitting ? "Sending Email..." : "Submit Report" }}
        </button>
      </div>

      <!-- Success/Error Messages -->
      <v-snackbar v-model="showSuccess" color="success" :timeout="5000">
        Report submitted successfully! Email sent to support@parkspass.org
      </v-snackbar>
      <v-snackbar v-model="showError" color="error" :timeout="5000">
        {{ errorMessage }}
      </v-snackbar>
    </main>
  </v-app>
</template>

<script>
import { parksJson } from "../assets/ParkFiles/parks.js";
import Header from "../components/Header.vue";
export default {
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      selectedPark: "",
      comments: "",
      passId: "",
      description: "",
      EventTable: parksJson,
      ParkList: [],
      attachedImages: [],
      errors: {
        first_name: [],
        last_name: [],
        email: [],
        phone: [],
        selectedPark: [],
      },
      isSubmitting: false,
      showSuccess: false,
      showError: false,
      errorMessage: "",
      serialNumber: this.$route.params.serial_number || "",
    };
  },
  components: {
    Header,
  },
  created() {
    // Populate ParkList from EventTable
    this.ParkList = this.EventTable.map((event) => event.name);
    this.ParkList = this.ParkList.filter(
      (park) => park !== "State Park Annual Pass"
    );
    // console.log("serial number:", this.serialNumber);
  },
  methods: {
    handleFileSelect(event) {
      const files = Array.from(event.target.files);

      files.forEach((file) => {
        // Validate file type
        if (!file.type.startsWith("image/")) {
          this.showErrorMessage("Please select only image files");
          return;
        }

        // Validate file size (max 5MB per image)
        if (file.size > 5 * 1024 * 1024) {
          this.showErrorMessage("Images must be smaller than 5MB");
          return;
        }

        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.attachedImages.push({
            file: file,
            name: file.name,
            size: file.size,
            type: file.type,
            preview: e.target.result,
            data: e.target.result, // Base64 data
          });
        };
        reader.readAsDataURL(file);
      });

      // Reset input
      event.target.value = "";
    },

    removeImage(index) {
      this.attachedImages.splice(index, 1);
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    },

    validateForm() {
      let isValid = true;
      this.errors = {
        first_name: [],
        last_name: [],
        email: [],
        phone: [],
        selectedPark: [],
      };

      if (!this.first_name.trim()) {
        this.errors.first_name.push("First name is required");
        isValid = false;
      }

      if (!this.last_name.trim()) {
        this.errors.last_name.push("Last name is required");
        isValid = false;
      }

      if (!this.email.trim()) {
        this.errors.email.push("Email is required");
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.errors.email.push("Please enter a valid email address");
        isValid = false;
      }

      if (!this.phone.trim()) {
        this.errors.phone.push("Phone number is required");
        isValid = false;
      }

      if (!this.selectedPark) {
        this.errors.selectedPark.push("Please select a park");
        isValid = false;
      }

      return isValid;
    },

    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },

    async submitForm() {
      if (!this.validateForm()) {
        this.showErrorMessage("Please fill in all required fields");
        return;
      }

      this.isSubmitting = true;

      try {
        // Prepare data to send
        const payload = {
          serial_number: this.serialNumber,
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          selectedPark: this.selectedPark,
          comments: this.comments,
          images: this.attachedImages.map((img) => ({
            name: img.name,
            type: img.type,
            data: img.data,
          })),
        };

        // Send to serverless function
        const response = await fetch("/sendSupportEmail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.error || "Failed to send email");
        }

        this.showSuccess = true;
        this.resetForm();
      } catch (error) {
        console.error("Error submitting form:", error);
        this.showErrorMessage(
          error.message || "Failed to submit form. Please try again."
        );
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.first_name = "";
      this.last_name = "";
      this.email = "";
      this.phone = "";
      this.selectedPark = "";
      this.comments = "";
      this.attachedImages = [];
      this.errors = {
        first_name: [],
        last_name: [],
        email: [],
        phone: [],
        selectedPark: [],
      };
    },

    showErrorMessage(message) {
      this.errorMessage = message;
      this.showError = true;
    },
  },
};
</script>

<style scoped>
.reg-textfield {
  width: 300px;
}
.comments-textarea {
  width: 100%;
}
.stolen-pass {
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
  flex-direction: column;
  align-items: center;
}
.box-cont {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  padding: 16px;
  width: 75%;
  margin-bottom: 20px;
}
.tiny-text {
  color: #212121;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
h1 {
  color: #000;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}
h2 {
  color: #000;
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}
h3 {
  color: #000;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-top: 16px;
  margin-bottom: 12px;
}
p {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.green-button {
  border-radius: 6px;
  background: #727a35;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding: 14px 32px;
  display: flex;
  align-items: center;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
}
.green-button:hover {
  background: #5f6429;
}
.green-button:disabled {
  background: #9e9e9e;
  cursor: not-allowed;
}
.green-button > span {
  margin-right: 8px;
}
.submit-button {
  margin-top: 8px;
}
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.6s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.center {
  display: flex;
  justify-content: center;
}
.attached-images {
  margin-top: 20px;
}
.image-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.image-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  gap: 12px;
}
.image-preview {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}
.image-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.image-name {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  color: #212121;
}
.image-size {
  font-family: Roboto;
  font-size: 12px;
  color: #757575;
}
.remove-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d32f2f;
  color: white;
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}
.remove-button:hover {
  background: #b71c1c;
}
@media only screen and (max-width: 425px) {
  .box-cont {
    width: 100%;
  }
  .reg-textfield {
    width: 100%;
  }
}
</style>
